

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class Tips extends Vue {
  @Prop() content!: string;
  visible: boolean = false;

  handleShowTips(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.visible = true;
    setTimeout(() => {
      this.visible = false;
    }, 2000);
  }
}
